// src/App.js
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { useAlert } from './context/AlertContext';
import { StepProvider } from './context/StepContext';
import { useStep } from './context/StepContext';
import FlashMessage from './components/FlashMessage';
import { useState } from 'react';

// API
import { login as loginApi } from './api/api';


import Header from './components/Layout/Header';
import SidebarMenu from './components/Layout/SidebarMenu';
import AuthStep from './components/Steps/AuthStep';
import Dashboard from './pages/Dashboard';

function AppContent() {
  const { user, loginUser, logout } = useAuth();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { step, goToStep } = useStep()
  const [flashMessage, setFlashMessage] = useState('');
  const [flashMessageType, setFlashMessageType] = useState('');


  // Handlers
  const handleLogin = async (lastName, userBadgeId) => {
    try {
      const res = await loginApi({ lastName, userBadgeId, role: 'user' });
      if (res.status === 200) {
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);
        loginUser(lastName, userBadgeId, { path: '/', expires });

        goToStep(0);
        navigate('/');
      } else {
        setFlashMessage('Invalid badge ID or last name.');
        setFlashMessageType('error');
      }
    } catch (err) {
      setFlashMessage('Server Error. Please try again later.');
      setFlashMessageType('error');
    }
  };

  return (
    <div className="bg-gray-100 flex flex-col justify-center items-center sm:justify-start text-black min-h-screen">
      <FlashMessage
        message={flashMessage}
        type={flashMessageType}
        onClose={() => {
          setFlashMessage('');
          setFlashMessageType('');
        }}
      />
      
      <Routes>
        {/* Auth route */}
        <Route path="/login" element={
          <>
            <Header logout={logout} user={user} />
            <AuthStep onLogin={handleLogin} />
          </>
        } />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            user ? (
              <div className="flex w-full max-w-screen h-screen min-h-screen">
                <SidebarMenu setStep={goToStep} step={step} adminVisible={user?.role === 'admin'} />
                <div className="flex-1">
                  <Header logout={logout} user={user} />
                  <Dashboard setStep={goToStep} step={step}/>
                </div>
              </div>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <StepProvider>
      <AppContent />
    </StepProvider>
  )
}
